export default "__VITE_ASSET__c6b995ce__"